import { AuthMethod } from '@infotech-soe/merps/types/session';
import { defineMessages } from 'react-intl';

export const loginFormMessages = defineMessages({
  login: {
    id: 'core.loginForm.login',
    defaultMessage: 'Login:',
  },
  password: {
    id: 'core.loginForm.password',
    defaultMessage: 'Password:',
  },
  application: {
    id: 'core.loginForm.application',
    defaultMessage: 'Application:',
  },
  newPassword: {
    id: 'core.loginForm.newPassword',
    defaultMessage: 'New Password',
  },
  newPasswordConfirm: {
    id: 'core.loginForm.newPasswordConfirm',
    defaultMessage: 'Confirmation',
  },
  loginSubtitle: {
    id: 'core.loginForm.loginSubtitle',
    defaultMessage: 'Enter your login and password',
  },
  windowsADSubtitle: {
    id: 'core.loginForm.windowsADSubtitle',
    defaultMessage: 'Enter your domain login and password',
  },
  noAvailableApps: {
    id: 'core.loginForm.noAvailableApps',
    defaultMessage: 'No applications available.',
  },
});

export const baseAuthFormMessages = defineMessages({
  title: {
    id: 'core.loginForm.header',
    defaultMessage: 'Sign in',
  },
  submit: {
    id: 'core.loginForm.submit',
    defaultMessage: 'OK',
  },
  changePassword: {
    id: 'core.loginForm.changePassword',
    defaultMessage: 'Change Password',
  },
  loginError: {
    id: 'core.loginForm.error',
    defaultMessage: 'Authentication failed',
  },
});

export const loginWrapperMessages = defineMessages({
  [AuthMethod.LOGIN]: {
    id: 'core.loginForm.tab.login',
    defaultMessage: 'User/Pass',
  },
  [AuthMethod.DIGITAL_SIGNATURE]: {
    id: 'core.loginForm.tab.digitalSignature',
    defaultMessage: 'Digital Signature',
  },
  [AuthMethod.WINDOWS_AD]: {
    id: 'core.loginForm.tab.windowsAD',
    defaultMessage: 'Domain Login',
  },
  noAuthMethods: {
    id: 'core.loginForm.noAuthMethods',
    defaultMessage: 'Sorry, no auth methods are supported by server.',
  },
  wrongTimeZone: {
    id: 'core.loginForm.wrongTimeZone',
    defaultMessage:
      'Sorry, your timezone is different from timezone. Set your timezone to {tz} and do not change it before you finish work with system.',
  },
  cannotConnectToServer: {
    id: 'core.loginForm.cannotConnectToServer',
    defaultMessage: 'Sorry, cannot connect to application server',
  },
  tryToReconnectLater: {
    id: 'core.loginForm.tryToReconnectLater',
    defaultMessage: 'Please try to refresh page later.',
  },
  userGuide: {
    id: 'core.loginForm.userGuide',
    defaultMessage: 'User Guide',
  },
});
